import { authService } from './authService';
import { getServerURL } from './config';

const SERVER_URL = getServerURL();

export const isPrivateStorageAssetUrl = (value) => {
  if (typeof value !== 'string' || !value) return false;

  try {
    const url = new URL(value);
    return url.searchParams.has('idrive')
      || (url.searchParams.has('exp') && url.searchParams.has('sig'));
  } catch {
    return false;
  }
};

export const shouldImmediatelyProxyAsset = (value) => {
  if (!isPrivateStorageAssetUrl(value) || typeof window === 'undefined') return false;
  return window.location.hostname === 'localhost'
    || window.location.hostname === '127.0.0.1';
};

const ASSET_PREVIEW_SIZES = new Set(['full', 'thumbnail', 'preview']);

export const normalizeAssetPreviewSize = (value) => (
  ASSET_PREVIEW_SIZES.has(value) ? value : 'full'
);

export const loadAssetPreview = async (url, size = 'full') => {
  const response = await fetch(`${SERVER_URL}/assets/preview`, {
    method: 'POST',
    headers: {
      ...authService.getAuthHeaders(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      url,
      size: normalizeAssetPreviewSize(size),
    }),
  });

  if (!response.ok) {
    const result = await response.json().catch(() => ({}));
    throw new Error(result.error || 'Failed to load asset preview');
  }

  return response.blob();
};
